import * as React from 'react';
import { KeyboardAvoidingView } from 'react-native';
import { Platform } from 'react-native';

export function CustomKeyboardAvoidingView(props) {
  const modifiedProps = Object.assign({}, props);
  if (Platform.OS === "ios") {
    modifiedProps.behavior = "padding";
  }
  return (
    <KeyboardAvoidingView
      {...modifiedProps}
      style={{
        flex: 1,
        ...modifiedProps.style,
      }}
    />
  );
}
